import WorkshopsData from '../containers/WorkshopsData';

const DevHosts = new Set([
	'localhost',
	'loki.repairy.au',
	'flyairy-partner-landing.onrender.com',
]);

export function resolveWorkshop(hostname, routeId) {
	if (!DevHosts.has(hostname)) {
		return WorkshopsData.find((w) => w.hostname === hostname) ?? null;
	}
	return WorkshopsData.find((w) => w.id === routeId) ?? null;
}

/** Path to the main homepage for this host (dev hosts use /:workshopId; prod uses /). */
export function mainSiteBasePath(hostname, routeWorkshopId) {
	if (DevHosts.has(hostname)) {
		return routeWorkshopId ? `/${routeWorkshopId}` : '/';
	}
	return '/';
}
